// @ts-nocheck
import { createStyle } from '@gluestack-style/react';
import { BaseIconVariants } from './Icon';

export const AlertIcon = createStyle({
  variants: BaseIconVariants,
  props: {
    size: 'md',
  },
});
